export const CHESS_DRAUGHTS_CLOCK_OPTIONS = [
  { value: JSON.stringify({ clockLimit: 60, clockIncrement: 0 }), label: '1+0 Bullet' },
  { value: JSON.stringify({ clockLimit: 120, clockIncrement: 1 }), label: '2+1 Bullet' },
  { value: JSON.stringify({ clockLimit: 180, clockIncrement: 0 }), label: '3+0 Blitz' },
  { value: JSON.stringify({ clockLimit: 180, clockIncrement: 2 }), label: '3+2 Blitz' },
  { value: JSON.stringify({ clockLimit: 300, clockIncrement: 0 }), label: '5+0 Blitz' },
  { value: JSON.stringify({ clockLimit: 300, clockIncrement: 3 }), label: '5+3 Blitz' },
  { value: JSON.stringify({ clockLimit: 600, clockIncrement: 0 }), label: '10+0 Rapid' },
  { value: JSON.stringify({ clockLimit: 600, clockIncrement: 5 }), label: '10+5 Rapid' },
  { value: JSON.stringify({ clockLimit: 900, clockIncrement: 10 }), label: '15+10 Rapid' },
];
